<template>
    <b-container class="bg-light mt-4 pb-1" style="min-height:700px">
        <page-heading heading="News"/>
        <div class="timeline-container bg-light mx-auto d-none d-md-block" v-if="sortedArticles">
            <b-row v-for="years in sortedArticles">
                <div v-for="(months_object, year) in years">
                    <b-btn size="lg" variant="link" v-b-toggle="'collapse' + year"><span class="h1 font-weight-bold">{{ year }}</span></b-btn>
                    <b-collapse :id="'collapse' + year">
                        <ul>
                            <div v-for="months in months_object">
                                <li v-for="(article_list, month) in months">
                                    <span></span>
                                    <div v-for="article in article_list">
                                        <a :href="article.file" target="_blank">
                                            <div class="row">
                                                <div class="col-6 d-none d-md-block">
                                                    <img :src="article.image" :alt="article.name" class="img-fluid rounded">
                                                </div>
                                                <div class="col-6">
                                                    <div class="h6">{{ article.name }}</div>
                                                    <div class="small">{{ article.date }}</div>
                                                </div>
                                            </div>
                                        </a>
                                    <hr>
                                    </div>
                                    <div class="date h4 text-primary">
                                        <span>{{ month }}</span>
                                    </div>
                                </li>
                            </div>
                        </ul>
                    </b-collapse>
                </div>
            </b-row>
        </div>
        <div class="bg-light mx-auto d-block d-md-none" v-if="sortedArticles">
            <b-row v-for="years in sortedArticles">
                <div v-for="(months_object, year) in years">
                    <b-btn size="lg" variant="link" v-b-toggle="'collapse' + year"><span class="h1 font-weight-bold">{{ year }}</span></b-btn>
                    <b-collapse :id="'collapse' + year">
                        <ul class="list-unstyled">
                            <div v-for="months in months_object">
                                <li v-for="(article_list, month) in months">
                                    <span></span>
                                    <div v-for="article in article_list">
                                        <a :href="article.file" target="_blank">
                                            <div class="row">
                                                <div class="offset-1 col-5 d-block d-md-none">
                                                    <img :src="article.image" :alt="article.name" class="img-fluid rounded">
                                                </div>
                                                <div class="col-4">
                                                    <div class="h6">{{ article.name }}</div>
                                                    <div class="small">{{ article.date }}</div>
                                                </div>
                                            </div>
                                        </a>
                                    <hr>
                                    </div>
                                    <div class="date h4 text-primary">
                                        <span>{{ month }}</span>
                                    </div>
                                </li>
                            </div>
                        </ul>
                    </b-collapse>
                </div>
            </b-row>
        </div>
    </b-container>
</template>
<script>
import PageHeading from '@/components/SharedComponents/PageHeading.vue'
import axios from 'axios'
import moment from 'moment'
export default {
    data() {
        return{
            articles: []
        }
    },
    computed: {
        sortedArticles() {
            let years = []
            let months = []
            Object.keys(this.articles).sort().reverse().forEach(year => {
                Object.keys(this.articles[year]).sort().reverse().forEach(month => {
                    months.push({[moment(month, 'MM').format('MMMM')]: this.articles[year][month]})
                })
                years.push({[year]: months})
                months = []
            })
            return years
        }
    },
    methods: {
        getArticles() {
            axios.get(this.API_URL + '/articles').then((response) => {
                this.articles = response.data
            }, (error) => {
                console.log(error)
            })
        }
    },
    components: {
        PageHeading
    },
    beforeCreate() {
        document.title = "News"
    },
    created() {
        
    },
    beforeMount() {
        
    },
    mounted() {
        this.getArticles()
    },
    beforeUpdate() {
        
    },
    updated() {

    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/news.vue